exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media only screen and (max-width: 960px){#monitor-table-set[data-v-1960ad1e]{flex-wrap:wrap}}#monitor-table-set .monitor-table-set__container[data-v-1960ad1e]{display:flex}@media only screen and (max-width: 767px){#monitor-table-set .monitor-table-set__container[data-v-1960ad1e]{flex-direction:column}}", ""]);

